/**
 * NFE.io SDK v3 - Resources Index
 *
 * Centralized exports for all API resources
 */

// Resource classes
export { ServiceInvoicesResource, createServiceInvoicesResource } from './service-invoices.js';
export { CompaniesResource, createCompaniesResource } from './companies.js';
export type { CertificateStatusSummary } from './companies.js';
export { LegalPeopleResource } from './legal-people.js';
export { NaturalPeopleResource } from './natural-people.js';
export { WebhooksResource } from './webhooks.js';
export { AddressesResource, createAddressesResource, ADDRESS_API_BASE_URL } from './addresses.js';
export { TransportationInvoicesResource, createTransportationInvoicesResource, CTE_API_BASE_URL } from './transportation-invoices.js';
export { InboundProductInvoicesResource, createInboundProductInvoicesResource } from './inbound-product-invoices.js';
export { ProductInvoiceQueryResource, createProductInvoiceQueryResource, NFE_QUERY_API_BASE_URL } from './product-invoice-query.js';
export { ConsumerInvoiceQueryResource, createConsumerInvoiceQueryResource } from './consumer-invoice-query.js';
export { LegalEntityLookupResource, createLegalEntityLookupResource, LEGAL_ENTITY_API_BASE_URL } from './legal-entity-lookup.js';
export { NaturalPersonLookupResource, createNaturalPersonLookupResource, NATURAL_PERSON_API_BASE_URL } from './natural-person-lookup.js';
export { TaxCalculationResource, createTaxCalculationResource } from './tax-calculation.js';
export { TaxCodesResource, createTaxCodesResource } from './tax-codes.js';
export { ProductInvoicesResource } from './product-invoices.js';
export { StateTaxesResource } from './state-taxes.js';
export { ServiceInvoicesRtcResource, createServiceInvoicesRtcResource } from './service-invoices-rtc.js';
export { ProductInvoicesRtcResource, createProductInvoicesRtcResource } from './product-invoices-rtc.js';
export { MunicipalTaxesResource, createMunicipalTaxesResource } from './municipal-taxes.js';
export { ConsumerInvoicesResource, createConsumerInvoicesResource } from './consumer-invoices.js';
export type { ConsumerInvoicePageOptions } from './consumer-invoices.js';
export { CertificatesResource, createCertificatesResource } from './certificates.js';
export { NotificationsResource, createNotificationsResource } from './notifications.js';
